module.exports = __webpack_public_path__ + "static/media/banner3.ddf1bed2.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/banner3.png
// module id = 43
// module chunks = 0